import React, { useState } from "react";
import { ModalCarouselContainer } from "./ModalCarouselStyled";

import close from './../../utils/images/close_circle.svg';
import avatar from './../../utils/images/avatar_fluincr.png';

import Carousel from 'react-material-ui-carousel';

export default function ModalCarouselCollaborations({ content, images, setShowModalCarousel, videos, collaboration, profileUserType }) {

    const [activeImage, setActiveimage] = useState(1);

    return (
        <ModalCarouselContainer>
            <div className="carouselBody">
                <div className="carouselHeader">
                    <img src={close} alt="close" onClick={() => { setShowModalCarousel(false) }} className="close" />
                </div>

                <Carousel
                    next={(next, active) => {
                        setActiveimage(next + 1)
                    }}
                    prev={(prev, active) => {
                        setActiveimage(prev + 1)
                    }}
                    autoPlay={false}
                    navButtonsAlwaysVisible={true}
                    indicators={false}
                    cycleNavigation={false}
                    swipe={true}
                    className='navButton'

                    navButtonsProps={{
                        style: {
                            backgroundColor: 'transparent',
                            color: '#ffffff',

                        },
                        button: {
                            margin: "0 10px",
                            position: "relative",
                            backgroundColor: "red",
                            top: "calc(50% - 20px) !important",
                            color: "white",
                            fontSize: "100px",
                            transition: "200ms",
                            cursor: "pointer",
                            '&:hover': {
                                opacity: "0.6 !important"
                            },
                        },
                    }}

                >

                    {content?.map((cont, index) =>
                    (<div className="imageContainer" key={index}>

                        {(JSON.parse(cont.title).name === 'photo') ? (<img src={cont.content} alt="cover" className='image' />) : (<video controls className="video">
                            <source src={cont.content} type="video/mp4" />
                        </video>)}

                        <div className="collaborationInfo">

                            {(profileUserType === 'company') && (<div className="imageColaborator" style={{ backgroundImage: `url(${(collaboration.image_influencer === null) ? avatar : collaboration.image_influencer})` }}>
                            </div>)}

                            {(profileUserType === 'influencer' || profileUserType === 'Influencer') && (<div className="imageColaborator" style={{ backgroundImage: `url(${(collaboration.imageprofile === null) ? avatar : collaboration.imageprofile})` }}>
                            </div>)}

                            <p className="nameColaborator">{(profileUserType === 'company') ? `${collaboration.givenname} ${collaboration.familyname}` : collaboration.namecompany}</p>
                        </div>

                    </div>
                    ))
                    }
                </Carousel>

            </div>
        </ModalCarouselContainer>
    )
}